import React from 'react';
import { SvgIcon } from '@mui/material';

interface PawnProps {
  pieceColor: 'white' | 'black';
}

const Pawn: React.FC<PawnProps> = ({ pieceColor }) => {
  return (
    <SvgIcon viewBox="0 0 17.253 17.253" sx={{ width: '100%', height: '75%', color: pieceColor, filter: 'drop-shadow(0 0 2px black)', border: 'none', paddingTop: '12%' }}>
      <g>
        <g>
          <path style={{ fill: 'currentColor' }} d="M5.224,12.875c0.059,0.001,2.15,0,3.239,0c1.085,0,3.673,0.001,3.732,0
            c0.1-0.004,0.343-0.196,0.278-0.436c-0.072-0.3-0.338-0.365-0.435-0.365c-0.07,0-2.173,0-3.258,0c0,0-0.257,0-0.638,0
            c-1.087,0-2.694,0-2.763,0c-0.096,0-0.363,0.065-0.436,0.365C4.881,12.678,5.124,12.871,5.224,12.875z" />
          <path style={{ fill: 'currentColor' }} d="M11.295,11.927C10.67,10.636,9.862,7.002,9.63,5.481h0.704c0.2,0,0.364-0.179,0.364-0.401
            c0-0.221-0.164-0.4-0.364-0.4H9.483L9.481,4.662c0.74-0.395,1.252-1.239,1.252-2.212C10.733,1.096,9.745,0,8.525,0
            S6.318,1.097,6.318,2.45c0,0.974,0.51,1.817,1.25,2.212L7.567,4.68H6.715c-0.202,0-0.364,0.179-0.364,0.4
            c0,0.222,0.162,0.401,0.364,0.401h0.704c-0.228,1.514-0.893,4.964-1.463,6.446H11.295z" />
          <g>
            <path style={{ fill: 'currentColor' }} d="M12.788,16.59c-0.077-0.214-0.346-0.452-0.346-0.452H4.81c0,0-0.267,0.21-0.357,0.437
              s-0.092,0.678-0.092,0.678h8.531C12.892,17.252,12.866,16.805,12.788,16.59z" />
            <polygon style={{ fill: 'currentColor' }} points="11.995,13.114 5.354,13.114 4.87,15.967 12.382,15.967 " />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default Pawn;
